export default "__VITE_ASSET__CIvvdGpp__"